<footer class="flex flex-col gap-16 pt-24 pb-32 sm:pt-48 lg:pb-12">
  <div class="mx-auto flex w-full max-w-[1200px] flex-col gap-4 px-4">
    <div class="flex flex-wrap justify-center gap-3 sm:gap-4">
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-visma.png"
        alt="Visma Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-lease-a-bike.png"
        alt="Lease a Bike Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-cervelo.png"
        alt="Cervelo Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-giro.png"
        alt="Giro Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-founders-of-loyalty.png"
        alt="Founders of Loyalty Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-jumbo.png"
        alt="Jumbo Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-mistral-ai.png"
        alt="Mistral AI Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-rabobank.png"
        alt="Rabobank Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-skil.png"
        alt="Skil Logo"
      />
      <img
        class="h-18 w-26 object-contain sm:h-20 sm:w-35 md:h-30 md:w-45"
        src="https://yellow-b-global.b-cdn.net/production/the-architect/images/logos/logo-partner-sram.png"
        alt="Sram Logo"
      />
    </div>
  </div>

  <span class="mx-auto text-center font-light text-white/80">
    © {new Date().getFullYear()} Team Visma | Lease a Bike
  </span>
</footer>
